module.exports = __webpack_public_path__ + "media/images/referencement-illu-02d64071846bda6792cafcf8799690bd.png";